/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button, TextField, Typography, Grid, Stack, styled, Box, Chip, Dialog, Card, CardContent, Paper, Divider, DialogTitle, DialogContent,
  DialogActions, TableCell, TableContainer, Table, TableRow, TableHead, TableBody
} from '@mui/material';
import moment from 'moment';
import { useTheme } from '@emotion/react';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { Container } from 'reactstrap';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DescriptionIcon from '@mui/icons-material/Description';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import VisibilityIcon from '@mui/icons-material/Visibility';
import useMediaQuery from '@mui/material/useMediaQuery';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import NoResultsFound from '../../../components/NoResultsFound';

const useStyles = styled((theme) => ({
  formContainer: {
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
  },
  header: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  infoCard: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
  },
  fileUploadArea: {
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    textAlign: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  previewImage: {
    width: '100%',
    height: 120,
    objectFit: 'cover',
    borderRadius: theme.shape.borderRadius,
  },
  submitButton: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(1.5),
    fontSize: '1rem',
  },
}));

const LedgerAdd = ({ setComplaintDialogOpenState, complaintDetail, getAllData = () => { }, }) => {
  const theme = useTheme();
  const classes = useStyles();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [selectedImageFiles, setSelectedImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [selectedDocFile, setSelectedDocFile] = useState(null);
  const [docPreview, setDocPreview] = useState('');
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [openFullScreenDialog, setOpenFullScreenDialog] = useState(false);
  const [currentFullScreenImage, setCurrentFullScreenImage] = useState('');
  const [showDocPreviewDialog, setShowDocPreviewDialog] = useState(false);
  const [complaintText, setComplaintText] = useState('');
  const complaintTextRef = useRef(null);
  const [complaintTextError, setComplaintTextError] = useState(false);
  const [getAllOrderData, setGetAllOrderData] = useState([]);
  const [showAcknowledgeConfirmation, setShowAcknowledgeConfirmation] = useState(false);
  const [terminateText, setTerminateText] = useState('');
  const [showTerminateConfirmation, setShowTerminateConfirmation] = useState(false);
  const [getAllComplaintStatusData, setGetAllComplaintStatusData] = useState([]);
  const [showComplaintStatus, setShowComplaintStatus] = useState(false);
  const config = {
    headers: {
      Country: sessionStorage.getItem('country'),
    },
  };

  const handleImageChange = (event) => {
    if (event.target.files) {
      const newFiles = Array.from(event.target.files);

      // Define allowed file types
      const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const maxSize = 3 * 1024 * 1024; // 3MB in bytes

      // Filter valid files (type & size)
      const validFiles = newFiles.filter((file) => {
        const isCorrectType = allowedTypes.includes(file.type);
        const isWithinSize = file.size < maxSize;
        return isCorrectType && isWithinSize;
      });

      // Check if any files were rejected
      if (validFiles.length !== newFiles.length) {
        const rejectedFiles = newFiles.length - validFiles.length;
        openSnackBar(
          `${rejectedFiles} file(s) were rejected. Only JPG/PNG/JPEG under 3MB allowed.`,
          'error'
        );
        return;
      }

      // const validFiles = newFiles.filter((file) => file.size < 3 * 1024 * 1024);
      // if (validFiles.length !== newFiles.length) {
      //   openSnackBar('Please select images below 3MB', 'error');
      //   return;
      // }
      setSelectedImageFiles((prevImages) => [...prevImages, ...validFiles]);
      validFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          setImagePreviews((prevImages) => [...prevImages, e.target.result]);
        };
        reader.readAsDataURL(file);
      });
      event.target.value = null;
    }
  };

  const handleDocChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];

      const allowedExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];
      const maxSize = 3 * 1024 * 1024; // 3MB

      // Check file extension
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const isValidExtension = allowedExtensions.includes(`.${fileExtension}`);

      // Check file size
      const isValidSize = file.size <= maxSize;

      if (!isValidExtension) {
        openSnackBar(
          'Only PDF, DOC, DOCX, XLS, and XLSX files are allowed.',
          'error'
        );
        return;
      }

      if (!isValidSize) {
        openSnackBar('File must be under 3MB.', 'error');
        return;
      }

      // if (file.size > 3 * 1024 * 1024) {
      //   openSnackBar('Please select a document below 3MB', 'error');
      //   return;
      // }
      setSelectedDocFile(file);
      setDocPreview(file.name);
      event.target.value = null;
    }
  };

  const handleDeleteImage = (index) => {
    setSelectedImageFiles((prev) => prev.filter((_, i) => i !== index));
    setImagePreviews((prev) => prev.filter((_, i) => i !== index));
    if (imagePreviews.length === 1) setOpenImageDialog(false);
  };

  const handleDeleteDocument = () => {
    setSelectedDocFile(null);
    setDocPreview('');
  };

  const handleImageClick = (image) => {
    setCurrentFullScreenImage(image);
    setOpenFullScreenDialog(true);
  };

  async function handleSubmitRegistration() {
    if (!complaintText.trim()) {
      setComplaintTextError(true);
      complaintTextRef.current.focus();
      return;
    }

    try {
      showLoading();
      const formData = new FormData();

      formData.append('BookingId', getAllOrderData[0].BookOrderId);
      formData.append('OrderId', complaintDetail.courierCargoId);
      formData.append('ShipmentType', complaintDetail.shipmentType === 'SCSL' ? 'Cargo' : 'Courier');
      formData.append('ComplaintReason', complaintText);
      formData.append('UserType', complaintDetail.userType);
      formData.append('CreatedBy', sessionStorage.getItem('UserId'));

      if (selectedImageFiles.length > 0) {
        selectedImageFiles.forEach((file) => {
          formData.append('DocImage', file);
        });
      } else if (selectedDocFile) {
        formData.append('DocImage', selectedDocFile);
      }

      const response = await axios.post(
        'Complaint/ComplaintCommon/InsertComplaint',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...config.headers,
          },
        }
      );

      setComplaintDialogOpenState(false);
      openSnackBar('Complaint registered successfully!', 'success');
      await sendMailForComplaint('ComplaintRegisterByCustomer')
      await getAllData();
      setComplaintText('');
      setSelectedImageFiles([]);
      setImagePreviews([]);
      setSelectedDocFile(null);
      setDocPreview('');
    } catch (e) {
      console.error('Error submitting complaint:', e);
      openSnackBar(e.response?.data?.message || 'Something went wrong. Please try again!', 'error');
    } finally {
      hideLoading();
    }
  }

  useEffect(() => {
    fetchOrderData();
  }, []);

  async function fetchOrderData() {
    showLoading();
    try {
      if (Number(complaintDetail.complaintId) === 0) {
        const response = await axios.post(
          'Complaint/ComplaintCommon/GetOneCourierCargoData',
          {
            Type: complaintDetail.shipmentType === 'SCSL' ? 'Cargo' : 'Courier',
            CourierCargoId: complaintDetail.courierCargoId,
          },
          config
        );
        if (response.data.length > 0) {
          setGetAllOrderData(response.data);
        } else {
          setGetAllOrderData([]);
        }
      } else {
        const response = await axios.post(
          'Complaint/ComplaintCommon/GetOneEditCourierCargoData',
          {
            Type: complaintDetail.shipmentType === 'SCSL' ? 'Cargo' : 'Courier',
            bookOrderId: complaintDetail.bookingOrderId,
            ComplaintId: complaintDetail.complaintId,
          },
          config
        );
        const {ComplaintData} = response.data;
        const {ComplaintDoc} = response.data;
        if (ComplaintData.length > 0) {
          setGetAllOrderData(response.data.ComplaintData);
          setComplaintText(ComplaintData[0].complaint_reason);
          if (ComplaintDoc.length > 0 && ComplaintDoc.some(doc => doc.complaint_document_name?.toLowerCase().endsWith('.jpg'))) {
            const modifiedDocs = ComplaintDoc.map((doc) => ({
              ...doc,
              url: `${axios.defaults.commonImageURL}/Complaint/${doc.complaint_document_name}`,
            }));
            setImagePreviews((prev) => [...prev, ...modifiedDocs]);
          } else {
            setDocPreview(ComplaintDoc[0]?.complaint_document_name);
            const url = `${axios.defaults.commonImageURL}/Complaint/${ComplaintDoc[0]?.complaint_document_name}`
            setSelectedDocFile(url)
          }
        } else {
          setGetAllOrderData([]);
        }
      }
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
      setGetAllOrderData([]);
      setComplaintDialogOpenState(false);
    }
    hideLoading();
  }

  const handleConfirmAcknowledge = () => {
    UpdateComplaint('Acknowledged');
    setShowAcknowledgeConfirmation(false);
  };

  const handleConfirmTerminate = () => {
    UpdateComplaint(getAllOrderData[0].Registered === 'Y' ? 'TerminateAfter' : 'TerminateBefore');
    setShowTerminateConfirmation(false);
  };

  async function UpdateComplaint(type) {
    const newData = {
      bookOrderId: getAllOrderData[0].BookOrderId,
      complaintId: complaintDetail.complaintId,
      shipmentType: complaintDetail.shipmentType === 'SCSL' ? 'Cargo' : 'Courier',
      Type: type,
      registerBy: sessionStorage.getItem('UserId'),
      terminateBy: sessionStorage.getItem('UserId'),
      terminate_reason: terminateText,
      complaint_reason: complaintText,
    };
    try {
      await axios.post('Complaint/ComplaintCommon/UpdateComplaint', newData, config);
      // setComplaintDialogOpenState(false);
      setComplaintText('');
      setTerminateText('');
      setImagePreviews([]);
      setSelectedDocFile(null);
      setSelectedImageFiles([]);
      setDocPreview('');
      await sendMailForComplaint(type === 'Acknowledged' ? 'ComplaintAcknowledged' : 'ComplaintTerminated')
      await getAllData();
      await fetchOrderData();
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
      setComplaintDialogOpenState(false);
      setComplaintText('');
      setTerminateText('');
    }
  }

  async function UpdateUnTerminateComplaint() {
    const newData = {
      bookOrderId: getAllOrderData[0].BookOrderId,
      shipmentType: complaintDetail.shipmentType === 'SCSL' ? 'Cargo' : 'Courier',
      unterminateBy: sessionStorage.getItem('UserId'),
      complaintId: complaintDetail.complaintId,
    };
    try {
      await axios.post('Complaint/ComplaintCommon/UpdateUnTerminateComplaint', newData, config);
      await sendMailForComplaint('ComplaintUnterminated')
      setComplaintDialogOpenState(false);
      await fetchOrderData();
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
      setComplaintDialogOpenState(false);
    }
  }

  async function fetchComplaintStatusData(Id) {
    showLoading();
    try {
      const response = await axios.post(
        'Complaint/ComplaintCommon/GetAllCompalintStatus',
        {
          shipmentType: complaintDetail.shipmentType === 'SCSL' ? 'Cargo' : 'Courier',
          bookOrderId: Id,
        },
        config
      );
      if (response.data.length > 0) {
        setGetAllComplaintStatusData(response.data);
      } else {
        setGetAllComplaintStatusData([]);
      }
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
      setGetAllComplaintStatusData([]);
      setComplaintDialogOpenState(false);
      setShowComplaintStatus(false);
    }
    hideLoading();
  }

  async function sendMailForComplaint(scenario) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendComplaintMail',
        {
          MailScenario: scenario,
          BookOrderId: getAllOrderData[0].BookOrderId,
          ShipmentType: complaintDetail.shipmentType === 'SCSL' ? 'Cargo' : 'Courier',
        },
        config
      );
    } catch (e) {
      openSnackBar('Mail Not send', 'error');
    }
    hideLoading();
  }

  return (
    <Container maxWidth={'xl'} sx={{ pt: 2 }}>
      {getAllOrderData.map((data, index) => (
        <Paper className={classes.formContainer} key={index}>
          {data?.Terminated === "Y" &&
            <Box sx={{ width: '100%', mb: 2 }}>
              <Chip
                label={`This complaint has been closed`}
                size="small"
                color="warning"
                variant="contained"
                icon={<ReportGmailerrorredIcon />}
                sx={{ width: '100%' }}
              />
            </Box>
          }
          {/* Header Section */}
          <Box className={classes.header}>
            <Typography variant="h5" component="h1" className="font_style1" color="primary" textAlign={'center'} style={{ fontWeight: '500' }}>
              Register Complaint
            </Typography>
            <Divider sx={{ my: 1 }} />
            {data.FormType === 'Edit' && (
              <Stack direction="row" spacing={4} mt={1} justifyContent="space-between" mb={1}>
                <Typography variant="body2">
                  <strong>Complaint ID:</strong> {data.complaint_id}
                </Typography>
                <Typography variant="body2">
                  <strong>Date:</strong> {moment(data.complaint_date).format('DD-MM-YYYY')}
                </Typography>
              </Stack>
            )}
          </Box>

          {/* Shipment Information */}
          <Typography variant="h6" className={classes.sectionTitle}>
            Shipment Information
          </Typography>
          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} md={3}>
              <Paper className={classes.infoCard}>
                <Typography variant="subtitle2" color="textSecondary">
                  Shipment Type
                </Typography>
                <Typography variant="body1">
                  {data.shipment_Type}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
              <Paper className={classes.infoCard}>
                <Typography variant="subtitle2" color="textSecondary">
                  Sender Country
                </Typography>
                <Typography variant="body1">
                  {data.SenderCountry}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
              <Paper className={classes.infoCard}>
                <Typography variant="subtitle2" color="textSecondary">
                  Receiver Country
                </Typography>
                <Typography variant="body1">
                  {data.ReceiverCountry}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={3}>
              <Paper className={classes.infoCard}>
                <Typography variant="subtitle2" color="textSecondary">
                  No. of Boxes
                </Typography>
                <Typography variant="body1">
                  {data.NoofBox}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper className={classes.infoCard}>
                <Typography variant="subtitle2" color="textSecondary">
                  Booking Information
                </Typography>
                <Stack direction="row" spacing={4}>
                  <Typography variant="body1">
                    <strong>Number:</strong> {data.BookOrderNo}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Date:</strong> {moment(data.BookDate).format('DD-MM-YYYY')}
                  </Typography>
                </Stack>
              </Paper>
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          {/* Complaint Details */}
          {/* <Stack direction="row" spacing={4} mt={1} justifyContent="space-between" mb={1}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Complaint Details <span style={{ color: 'red' }}>*</span>
            </Typography>
            {data.FormType === 'Edit' && (
              <Button
                variant="contained"
                color="success"
                size="small"
                onClick={() => {
                  setShowComplaintStatus(true);
                  fetchComplaintStatusData(data.BookOrderId);
                }}
              >
                Status
              </Button>
            )}
          </Stack> */}
          <Stack direction="row" spacing={4} mt={1} justifyContent="space-between" mb={1}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Complaint Details <span style={{ color: 'red' }}>*</span>
            </Typography>
            {data.FormType === 'Edit' && (
              <Button
                variant="contained"
                size="small"
                onClick={() => {
                  setShowComplaintStatus(true);
                  fetchComplaintStatusData(data.BookOrderId);
                }}
                sx={{
                  background: 'linear-gradient(135deg, #1976d2, #2196f3)', // Blue gradient
                  color: 'white',
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                  animation: 'pulse 2s infinite',
                  '@keyframes pulse': {
                    '0%': { boxShadow: '0 0 0 0 rgba(33,150,243, 0.7)' }, // rgba of #2196f3
                    '70%': { boxShadow: '0 0 0 10px rgba(33,150,243, 0)' },
                    '100%': { boxShadow: '0 0 0 0 rgba(33,150,243, 0)' }
                  },
                  '&:hover': {
                    background: 'linear-gradient(135deg, #1565c0, #1976d2)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
                  },
                  transition: 'all 0.3s ease',
                  padding: '6px 16px',
                  textTransform: 'none',
                }}
                startIcon={<VisibilityIcon />} // Different icon for "View"
              >
                Check Status
              </Button>
            )}
          </Stack>

          <TextField
            multiline
            inputRef={complaintTextRef}
            rows={4}
            variant="outlined"
            fullWidth
            placeholder="Please describe your complaint in detail..."
            value={complaintText}
            onChange={(e) => setComplaintText(e.target.value)}
            error={complaintTextError}
            helperText={complaintTextError ? "Complaint text is required." : ""}
            sx={{ mb: 3 }}
            disabled={data.FormType === 'Edit'}
          />

          {/* Attachments */}
          {(data.FormType === 'New') && (
            <div>
              <Typography variant="h6" className={classes.sectionTitle}>
                Attachments
              </Typography>
              <Typography variant="body2" color="textSecondary" mb={2}>
                Upload images or documents to support your complaint (Max 3MB each)
              </Typography>

              <Grid container spacing={2}>
                {!docPreview &&
                  <Grid item xs={12} md={6}>
                    <label htmlFor="image-button-file">
                      <Paper className={classes.fileUploadArea}>
                        <CloudUploadIcon fontSize="large" color="primary" />
                        <Typography variant="body1" mt={1}>
                          Click to upload images
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          JPG, PNG (Max 3MB)
                        </Typography>
                        <input
                          accept="image/jpeg,image/png,image/jpg"
                          style={{ display: 'none' }}
                          id="image-button-file"
                          multiple
                          type="file"
                          onChange={handleImageChange}
                        />
                      </Paper>
                    </label>
                  </Grid>
                }
                {!(imagePreviews.length > 0) && (
                  <Grid item xs={12} md={6}>
                    <label htmlFor="doc-button-file">
                      <Paper className={classes.fileUploadArea}>
                        <CloudUploadIcon fontSize="large" color="primary" />
                        <Typography variant="body1" mt={1}>
                          Click to upload documents
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          PDF, DOC (Max 3MB)
                        </Typography>
                        <input
                          accept=".pdf,.doc,.docx,.xls,.xlsx"
                          style={{ display: 'none' }}
                          id="doc-button-file"
                          type="file"
                          onChange={handleDocChange}
                        />
                      </Paper>
                    </label>
                  </Grid>
                )}
              </Grid>
            </div>
          )}

          {/* Preview Section */}
          {(imagePreviews.length > 0 || docPreview) && (
            <Box mt={3}>
              {data.FormType === 'New' && (
                <Typography variant="h6" className={classes.sectionTitle}>
                  Attachments
                </Typography>
              )}
              <Typography variant="subtitle1" mb={1}>
                Uploaded Files
              </Typography>
              <Grid container spacing={2}>
                {imagePreviews.map((preview, index) => (
                  <Grid item xs={6} sm={4} md={3} key={index}>
                    <Box position="relative">
                      {data.FormType === 'New' && (
                        <IconButton
                          size="small"
                          style={{ position: 'absolute', right: 4, top: 4, backgroundColor: 'rgba(0,0,0,0.5)', color: 'white' }}
                          onClick={() => handleDeleteImage(index)}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                      <img
                        src={typeof preview === 'string' ? preview : preview.url}
                        alt={`Preview ${index + 1}`}
                        className={classes.previewImage}
                        onClick={() => handleImageClick(typeof preview === 'string' ? preview : preview.url)}
                        style={{ cursor: 'pointer' }}
                      />
                    </Box>
                  </Grid>
                ))}
                {docPreview && (
                  <Grid item xs={12}>
                    <Chip
                      label={docPreview}
                      // onClick={() => setShowDocPreviewDialog(true)}
                      onClick={() => {
                        // Check if it's a URL (starts with http:// or https://)
                        if (selectedDocFile.startsWith('http://') || selectedDocFile.startsWith('https://')) {
                          // For URL, open in new tab or download directly
                          window.open(selectedDocFile, '_blank');
                        } else {
                          // For local files, trigger download
                          const link = document.createElement('a');
                          link.href = URL.createObjectURL(selectedDocFile); // Assuming selectedDocFile is a File object
                          link.download = selectedDocFile.name || 'document';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }
                      }}
                      variant="outlined"
                      icon={<DescriptionIcon />}
                      {...(data.FormType === 'New' && {
                        onDelete: handleDeleteDocument,
                        deleteIcon: <CloseIcon />,
                      })}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>
          )}

          {/* Submit Button */}
          {data.FormType === 'New' ? (
            <Box display="flex" justifyContent="flex-end" mt={4}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={classes.submitButton}
                onClick={handleSubmitRegistration}
                disabled={!complaintText.trim()}
              >
                Submit Complaint
              </Button>
            </Box>
          ) : (
            <>
              {complaintDetail.userType !== 'Customer' && (
                <Box display="flex" justifyContent="flex-end" mt={4} gap={2}>
                  <Button
                    variant="outlined"
                    color="error"
                    size="large"
                    className={classes.actionButton}
                    onClick={() => {
                      if (data.Terminated === 'Y') {
                        const isConfirmed = window.confirm("Do you want to unterminate this complaint?");
                        if (isConfirmed) {
                          UpdateUnTerminateComplaint()
                        }
                      } else {
                        setShowTerminateConfirmation(true)
                      }
                    }}
                  >
                    {data.Terminated === 'Y' ? 'UnTerminate' : 'Terminate'}
                  </Button>
                  {data.Register === 'N' && (
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      className={classes.actionButton}
                      onClick={() => setShowAcknowledgeConfirmation(true)}
                    >
                      Acknowledge
                    </Button>
                  )}
                </Box>
              )}
            </>
          )}
        </Paper>
      ))}

      {/* Image Preview Dialog */}
      <Dialog open={openImageDialog} onClose={() => setOpenImageDialog(false)} maxWidth="md">
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Uploaded Images
            </Typography>
            <Grid container spacing={2}>
              {imagePreviews.map((preview, index) => (
                <Grid item xs={6} sm={4} key={index}>
                  <Box position="relative">
                    <IconButton
                      size="small"
                      style={{ position: 'absolute', right: 4, top: 4, backgroundColor: 'rgba(0,0,0,0.5)', color: 'white' }}
                      onClick={() => handleDeleteImage(index)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                    <img
                      src={preview}
                      alt={`Preview ${index + 1}`}
                      style={{ width: '100%', height: 150, objectFit: 'cover', cursor: 'pointer' }}
                      onClick={() => handleImageClick(preview)}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        </Card>
      </Dialog>

      {/* Full Screen Image Dialog */}
      <Dialog
        fullScreen
        open={openFullScreenDialog}
        onClose={() => setOpenFullScreenDialog(false)}
        sx={{
          '& .MuiDialog-paper': {
            margin: 0,
            padding: 0,
            height: '100vh',
            width: '100vw',
            backgroundColor: 'rgba(0,0,0,0.9)',
            overflow: 'hidden',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }}
      >
        <IconButton
          edge="end"
          color="inherit"
          onClick={() => setOpenFullScreenDialog(false)}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }}
        >
          <CloseIcon />
        </IconButton>
        <img
          src={currentFullScreenImage}
          alt="fullscreen-preview"
          style={{
            maxHeight: '90vh',
            maxWidth: '90vw',
            objectFit: 'contain',
          }}
        />
      </Dialog>

      {/* Document Preview Dialog */}
      <Dialog open={showDocPreviewDialog} onClose={() => setShowDocPreviewDialog(false)} maxWidth="md" fullWidth>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Document Preview
            </Typography>
            <Box sx={{ height: '70vh' }}>
              {/* {selectedDocFile &&
                <embed
                  src={URL.createObjectURL(selectedDocFile)}
                  type="application/pdf"
                  width="100%"
                  height="100%"
                />
              } */}
              {selectedDocFile || (docPreview && (docPreview.startsWith('http://') || docPreview.startsWith('https://'))) ? (
                <embed
                  src={
                    typeof selectedDocFile === 'string'
                      ? selectedDocFile  // It's a URL string
                      : URL.createObjectURL(selectedDocFile)  // It's a File object
                  }
                  type={
                    selectedDocFile
                      ? selectedDocFile.type === 'application/pdf'
                        ? 'application/pdf'
                        : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                      : docPreview.endsWith('.pdf')
                        ? 'application/pdf'
                        : docPreview.endsWith('.docx')
                          ? 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                          : 'application/octet-stream'
                  }
                  width="100%"
                  height="100%"
                />
              ) : (
                <Typography>No document available for preview</Typography>
              )}
            </Box>
          </CardContent>
        </Card>
      </Dialog>

      {/* Confirmation Dialog */}
      <Dialog open={showAcknowledgeConfirmation} onClose={() => setShowAcknowledgeConfirmation(false)}>
        <DialogTitle>Confirm Acknowledgement</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to acknowledge?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAcknowledgeConfirmation(false)} color="warning" variant="contained">
            Cancel
          </Button>
          <Button
            onClick={handleConfirmAcknowledge}
            variant="contained"
            color="primary"
            size="success"
            sx={{ boxShadow: 1 }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Terminate Dialog */}
      <Dialog
        open={showTerminateConfirmation}
        PaperProps={{
          style: {
            borderRadius: '12px',
            padding: '10px',
          },
        }}
      >
        <DialogTitle sx={{ textAlign: 'center' }}>{`Confirm Termination`}</DialogTitle>
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              color: '#555',
            }}
          >
            {`Please provide a reason for terminating this complaint before we proceed. Do you confirm this action?`}
          </Typography>
          <TextField
            fullWidth
            size="small"
            label="Reason for Termination"
            multiline
            rows={4}
            placeholder="Please provide a reason for termination..."
            value={terminateText}
            onChange={(e) => setTerminateText(e.target.value)}
            InputProps={{
              style: {
                borderRadius: '8px',
              },
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#ccc',
                },
                '&:hover fieldset': {
                  borderColor: '#aaa',
                },
              },
            }}
          />
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: 'center',
            gap: '16px',
            padding: '16px',
          }}
        >
          <Button onClick={() => setShowTerminateConfirmation(false)} variant="contained" color="warning" >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmTerminate}
            variant="contained"
            color="error"
            disabled={!terminateText.trim()}
          >
            Terminate Complaint
          </Button>

        </DialogActions>
      </Dialog>


      {/* Complaint Status */}
      <Dialog open={showComplaintStatus} onClose={() => setShowComplaintStatus(false)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            Complaints Progress
          </Typography>
        </DialogTitle>
        <DialogContent>
          {getAllComplaintStatusData.length > 0 ? (
          <TableContainer component={Paper} sx={{ marginTop: 1 }}>
            <Table aria-label="complaints progress table">
              <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Updated On</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getAllComplaintStatusData.map((complaint) => (
                  <TableRow key={complaint.SlNo}>
                    <TableCell>{complaint.SlNo}</TableCell>
                    <TableCell>{complaint.UStatus}</TableCell>
                    <TableCell>{moment.utc(complaint.UDate).format('DD-MM-YYYY')}</TableCell>
                  </TableRow>
                ))}
                {/* {getAllOrderData[0]?.Terminated === "Y" &&
                  getAllOrderData.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell colSpan={2}>{data.terminate_reason}</TableCell>
                      <TableCell>{moment(data.TerminatedOn).format('LLL')}</TableCell>
                    </TableRow>
                  ))
                } */}
              </TableBody>
            </Table>
          </TableContainer>
          ):(<NoResultsFound />)}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowComplaintStatus(false)}
            variant="contained"
            color="primary"
            sx={{
              margin: 1,
              textTransform: 'none',
              padding: '6px 16px'
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>


    </Container>
  );
};

export default LedgerAdd;